import { createFileRoute, notFound } from "@tanstack/react-router";
import guidesStyles from "../styles/guides.css?url";
import { withStylesheet } from "../lib/head";
import { loadGuides } from "../platform/guides";
import { GuidesIndex } from "../platform/guides/guides-pages";
import { platformPageHead, platformShellFrom } from "../platform/head";

/** /guides: Drate's articles for creators (Drate's host only). */
export const Route = createFileRoute("/guides/")({
  loader: async () => {
    const page = await loadGuides();
    if (!page) throw notFound();
    return page;
  },
  head: ({ matches, loaderData }) =>
    loaderData
      ? withStylesheet(
          platformPageHead(platformShellFrom(matches), {
            pathname: "/guides",
            title: "Guides for creators | Drate",
            description:
              "Straight answers for creators: what Patreon, Substack, Ko-fi, Skool and Stan Store really take, and how to make a membership website of your own.",
            canonicalPath: "/guides",
            structuredData: loaderData.structuredData,
          }),
          guidesStyles,
        )
      : {},
  component: () => <GuidesIndex page={Route.useLoaderData()} />,
});
